// removed by extract-text-webpack-plugin
module.exports = {"confidence":"confidence","confidence_wrapper":"confidence_wrapper","confidence_row":"confidence_row","confidence_subtitle":"confidence_subtitle","dark":"dark"};


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/Project/components/ConfidenceBlock/style.scss
// module id = 1328
// module chunks = 0